import React, { lazy, Suspense } from "react";
import Box from "@mui/material/Box";

const SearchForm = lazy(() => import("./SearchForm"));

const searchFallbackSx = {
  position: "absolute",
  bottom: { xs: "12%", sm: "7%" },
  left: "50%",
  transform: "translateX(-50%)",
  width: { xs: "92%", sm: "100%" },
  maxWidth: { xs: 420, sm: 980 },
  height: { xs: 88, sm: 72 },
  borderRadius: "14px",
  background: "rgba(255,255,255,0.2)",
  border: "1px solid rgba(255,255,255,0.25)",
  zIndex: 2,
  pointerEvents: "none",
};

export default function HomeSearchForm(props) {
  return (
    <Suspense fallback={<Box sx={searchFallbackSx} aria-hidden="true" />}>
      <SearchForm {...props} />
    </Suspense>
  );
}
